import { useEffect } from 'react';

import { browserMetrics } from '@atlassian/browser-metrics';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { withTransparentErrorBoundary } from '@confluence/error-boundary/entry-points/withErrorBoundary.ts';

export type Props = {
	name: string;
};
const PageLoadMarkComponent = ({ name }: Props) => {
	const pageLoadMetric = browserMetrics.getPageLoadMetric();
	useEffect(() => {
		pageLoadMetric.mark(name);
	}, [pageLoadMetric, name]);

	return null;
};

/**
 * @deprecated Use `LoadMark` from `@confluence/browser-metrics/entry-points/LoadMark`
 * instead. It automatically switches between the BM3 and UFO implementations based on the
 * `confluence_fe_deprecate_bm3` feature gate. Direct usage of `PageLoadMark` will be
 * removed as part of the BM3 deprecation (CCP-7117).
 */
export const PageLoadMark = withTransparentErrorBoundary({
	attribution: Attribution.BACKBONE,
})(PageLoadMarkComponent);
